// extracted by mini-css-extract-plugin
module.exports = {"heroWrap":"Hero_heroWrap__31xpL","content":"Hero_content__UnxWH"};